class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.intervalHours = +this.dataset.interval || 24; 
    this.restart = this.dataset.restart || 30
    this.intervalMs = this.intervalHours * 60 * 60 * 1000;

    this.timer = null;
  }

  connectedCallback() {
    this.initTimer();
  }

  initTimer() {
    const savedEndDate = localStorage.getItem('countdownEndDate');

    if (savedEndDate) {
      this.endDate = new Date(savedEndDate);

      if (this.endDate <= new Date()) {
        this.clearTimerData();
        this.startNewTimer();
      }
    } else {
      this.startNewTimer();
    }
    this.startCountdownLoop();
  }

  startNewTimer() {
    this.startDate = new Date();
    this.endDate = new Date(this.startDate.getTime() + this.intervalMs);

    localStorage.setItem('countdownStartDate', this.startDate.toISOString());
    localStorage.setItem('countdownEndDate', this.endDate.toISOString());

    this.displayDates(this.startDate, this.endDate);
  }

  clearTimerData() {
    localStorage.removeItem('countdownStartDate');
    localStorage.removeItem('countdownEndDate');
  }

  startCountdownLoop() {
    if (this.timer) {
      clearInterval(this.timer);
    }

    this.updateCountdown(); 
    this.timer = setInterval(() => this.updateCountdown(), 1000);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  setCookie(name, value, seconds) {
    document.cookie = `${name}=${value}; max-age=${seconds}; path=/`;
  }

  updateCountdown() {
    const cookie = this.getCookie('restartDate');
    if (cookie) {
      this.setCountdownToZero();
      return;
    }

    const now = Date.now();
    const timeLeft = this.endDate - now;

    if (timeLeft <= 0) {
      this.setCountdownToZero();
      this.setCookie('restartDate', '1', this.restart);
      this.clearTimerData();

      setTimeout(() => {
        this.startNewTimer();
        this.displayDates(this.startDate, this.endDate);
      }, 1000);
      return;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    if (this.querySelector('#days')) {
      this.querySelector('#days').innerHTML = days;
    }
    this.querySelector('#hours').innerHTML = hours;
    this.querySelector('#minutes').innerHTML = minutes;
    this.querySelector('#seconds').innerHTML = seconds;
  }

  setCountdownToZero() {
    if (this.querySelector('#days')) {
      this.querySelector('#days').innerHTML = 0;
    }
    this.querySelector('#hours').innerHTML = 0;
    this.querySelector('#minutes').innerHTML = 0;
    this.querySelector('#seconds').innerHTML = 0;
  }

  displayDates(startDate, endDate) {
    const sectionTitle = this.querySelector('h2');
    if (!sectionTitle) return;

    const { pattern } = sectionTitle.dataset;

    sectionTitle.innerHTML = pattern
      .replace('[start]', this.dateFormatter(startDate))
      .replace('[end]', this.dateFormatter(endDate));
  }

  dateFormatter(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    return `${day}.${month}`;
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
